import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { Image } from 'semantic-ui-react'
import './Icon_indo_curso.css'

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      Width: "350px",
      position: "relative",
      marginLeft: "40px",
      marginRight: "40px",
      marginBottom: "2px"
    //   backgroundColor: "red",
    },
    icon: {
      width: "50px",
      height: "50px",
    },
    titulo:{
        fontWeight: "bold",
        marginLeft: "10px",
        marginTop: "5px",
    },
    fecha:{
        fontSize: "15px",
        marginLeft: "10px",
    }
  }));

function Icon_Info_curso(props: { icono: string | undefined; titulo: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; info: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }) {
    const classes = useStyles();
    return (
        <div className="contenedor_iconr">
            <Image src={props.icono} circular style={{width:"60px", height:"60px"}}/>
            <div className="">
                <p className={classes.titulo}>{props.titulo}</p>
                <p className={classes.fecha}>{props.info}</p>
            </div>
        </div>
    );
}

export default Icon_Info_curso;